import { render, staticRenderFns } from "./forgot-password.html?vue&type=template&id=5dd2729a&scoped=true&"
import script from "./forgot-password.js?vue&type=script&lang=js&"
export * from "./forgot-password.js?vue&type=script&lang=js&"
import style0 from "./forgot-password.scss?vue&type=style&index=0&id=5dd2729a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd2729a",
  null
  
)

export default component.exports